import { Button } from "@/js/glidespec";
import { useConnectorLink } from "@/js/Layouts/Connector";
import CircleExclamationIcon from "@/svg/circle-exclamation-regular.svg?react";
import React from "react";
import { useTranslation } from "react-i18next";

export default function Error() {
    const {t} = useTranslation();
    const { connectorLink: {user: {first_name, last_name}} } = useConnectorLink();

    return (
        <div className="bg-bg-100 shadow-card rounded-xl flex flex-col items-center px-6 py-10 gap-10 max-w-[500px] w-full">
            <CircleExclamationIcon className="fill-warning size-15" />
            <div className="flex flex-col gap-6 items-center">
                <h1 className="heading-xl text-center">{t("connector.error.title")}</h1>
                <p className="body-m text-center">{t("connector.error.text", {firstName: first_name, lastName: last_name})}</p>
                <Button variant="primary" to="..">{t("connector.error.retry")}</Button>
            </div>
        </div>
    )
}